import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useKeyDown } from '@wix/da-hooks/pkg/useKeyDown';
import CommentBoxPanel from '../CommentBoxPanel';
import { useCustomTransitionEvents } from './useCustomTransitionEvents';
import s from './PanelPopup.scss';
const PanelPopup = ({ visiblePanel , deviation , className , onClose  })=>{
    const isVisible = !!visiblePanel;
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(isVisible);
    useKeyDown(isVisible ? {
        Esc: onClose,
        Escape: onClose
    } : {});
    const { openAnimationEvent , closeAnimationEvent , closeEvent  } = useCustomTransitionEvents(rootRef, isVisible, visiblePanel);
    useEffect(()=>{
        const onPanelOpen = ()=>setIsOpen(true);
        const onPanelClose = ()=>setIsOpen(false);
        openAnimationEvent.addListener(onPanelOpen);
        closeEvent.addListener(onPanelClose);
        return ()=>{
            openAnimationEvent.removeListener(onPanelOpen);
            closeEvent.removeListener(onPanelClose);
        };
    }, [
        closeEvent,
        openAnimationEvent
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: rootRef,
        className: classnames(s['root'], isVisible && s['visible'], isVisible && isOpen && s['open'], visiblePanel && s[visiblePanel], s['uplifted'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['panel']
    }, visiblePanel === 'comment' && /*#__PURE__*/ React.createElement(CommentBoxPanel, {
        panelOpenEvent: openAnimationEvent,
        panelCloseEvent: closeAnimationEvent,
        deviation: deviation,
        onClose: onClose
    }))));
};
PanelPopup.displayName = 'PanelPopup';
export default PanelPopup;
